import * as React from 'react';

export function listExceptions(
  list: any[],
  key: string
): React.ReactChild {
  if (list.length === 0) {
    return <>—</>;
  }
  const visibles = list.filter(item => item.visible);
  const hiddens = list.filter(item => !item.visible);
  return (
    <>
      {visibles.length > 0 && <p className={hiddens.length > 0 ? 'mb-2' : ''}>
        Visible in {visibles.map(item => item[key].name).join(', ')}
      </p>}
      {hiddens.length > 0 && <p>
        Hidden in {hiddens.map(item => item[key].name).join(', ')}
      </p>}
    </>
  );
}


// WEBPACK FOOTER //
// ./src/views/Admin/services/listExceptions.tsx